/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

 define([
     "i18n/i18n",
     "utils/url",
     "utils/browser",
     "jquery",
     "underscore",
     "backbone",
     "service/channel"
   ], function(
     i18n,
     URL,
     browser,
     $,
     _,
     Backbone,
     Channel
   ) {
  // **IFRAME_TIMEOUT_MS** defines the time the channel waits for the
  // messageFrame to load and post the first message. If no message
  // is received a disconnected notification is sent with the reason
  // **TIMEOUT**.
  var IFRAME_TIMEOUT_MS = 10000,
      VERIFY_CONNECTION_TIMEOUT_MS = IFRAME_TIMEOUT_MS;

  // global registry for messageframes
  var frames = {};

  var LoginHandler = function () {
    this.loginWindows = {};
    this.cleanUp = {};
  }

  _.extend(LoginHandler.prototype, {

      showLogin: function (channel) {
        var that = this,
            id = this.getId(channel),
            loginWindow = this.getLoginWindow(channel),
            loginCancelled = true;

        if (!idpRegistry.idpEnabled(idpRegistry.getIdp(channel))) return;

        if (!loginWindow) {
          var modal = document.createElement("div");
          modal.className = "modal mb-login";
          modal.innerHTML = '<div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&#x2715;</button><h4 class="modal-title"> ' + i18n("login") + '</h4></div><div class="modal-body"> </div> </div> </div>';

          $(modal).on("hidden", function () {
            if (loginCancelled) {
              idpRegistry.disableIdp(idpRegistry.getIdp(channel));
            }
            that.hideLogin(channel);
          });

          var iframe = document.createElement("iframe");
          iframe.src = this.getLoginUrl(channel);
          iframe.title = "Login";
          iframe.setAttribute("data-channel", channel.get("url"));
          $(modal).find(".modal-body")[0].appendChild(iframe);

          this.loginWindows[id] = iframe;
          this.cleanUp[id] = (this.cleanUp[id] || []).concat(function () {
            loginCancelled = false;
            $(modal).modal("hide").remove();
          });

          document.body.appendChild(modal);
          $(modal).modal();
        }

        return this.loginWindows[id];
      },

      hideLogin: function (channel) {
        var that = this,
            id = this.getId(channel),
            loginWindow = this.getLoginWindow(channel);

        if (loginWindow) {
          // window
          try {
            _.defer(function () {
              if (loginWindow.close) loginWindow.close();
            });
          } catch (e) {}
          
          // iframe
          try {
            loginWindow.parentNode.removeChild(loginWindow);
          } catch (e) {}

          delete that.loginWindows[id];

          _.each(this.cleanUp[id], function (func) {
            func.apply(this, []);
          });
          delete this.cleanUp[id];

          if (this.$focusAfterLogin) this.$focusAfterLogin.focus();
        }
      },

      getLoginWindow: function (channel) {
        return this.loginWindows[this.getId(channel)];
      },

      getId: function (channel) {
        var idp = channel.idpURL,
            id = idp || channel.get("url");

        return id;
      },

      getLoginUrl: function (channel) {
        var cacheBuster = new Date().getTime(),
            dataSource = channel.get("url") + "/../../../",
            loginUrl = dataSource + "mashup-login?inDialog=true&origin=" + URL.getOriginFromDataSource(window.location.href);

        return loginUrl;
      },

      loginInBackground: function (channel) {
        var that = this;
        if (_.isArray(channel)) {
          _.each(channel, function (c) {
              that.loginInBackground(c);
          });
          return;
        }

        if (channel.get("loggedIn")) return;

        var that = this,
            id = this.getId(channel),
            loginWindow = this.getLoginWindow(channel);

        if (!loginWindow) {
          // abandon background login after 30 seconds
          _.delay(function () {
              that.hideLogin(channel);
              that.showLogin(channel);
          }, 30000);
  
          var iframe = document.createElement("iframe");
          iframe.style.display = "none";
          iframe.src = this.getLoginUrl(channel);
          iframe.title = "login in background";
          iframe.setAttribute("data-channel", channel.get("url"));
          document.body.appendChild(iframe);
          this.loginWindows[this.getId(channel)] = iframe;
        }
      }
  });

  var loginHandler = new LoginHandler();

  var IdpRegistry = function () {
    this._dataSourceToIdp = {};
    this._idpToDataSources = {};
    this._idpEnabled = {};
  };

  _.extend(IdpRegistry.prototype, Backbone.Events, {
    register: function (idp, channel) {
      if (!channel) return;
      if (!idp || idp === "null") {
        idp = channel.get("dataSource");
      }

      var dataSources = this._idpToDataSources[idp] || [];
      if (_.indexOf(_.map(dataSources, function (channel) {
          return channel && channel.get("dataSource");
        }), channel.get("dataSource")) < 0) dataSources.push(channel);
      this._idpToDataSources[idp] = dataSources;

      this._dataSourceToIdp[channel.get("dataSource")] = idp;
    },

    getIdp: function (messageFrameOrChannel) {
      return this._dataSourceToIdp[messageFrameOrChannel.get("dataSource") || (messageFrameOrChannel.messageFrame && messageFrameOrChannel.messageFrame.get("dataSource"))];
    },

    getChannelsForIdp: function (idpURL) {
      return this._idpToDataSources[idpURL];
    },

    enableIdp: function (idpURL) {
      if (!this.idpEnabled(idpURL)) {
        this._idpEnabled[idpURL] = true;
        this.trigger("idpenabledchanged", this.idpEnabled(idpURL));
      }
    },

    disableIdp: function (idpURL) {
      if (this.idpEnabled(idpURL)) {
        this._idpEnabled[idpURL] = false;
        this.trigger("idpenabledchanged", this.idpEnabled(idpURL));
      }
    },

    idpEnabled: function (idpURL) {
      var enabled = this._idpEnabled[idpURL];
      return enabled || typeof enabled === "undefined";
    }

  });

  var idpRegistry = new IdpRegistry();

     var normalizeDataSource = function (dataSource) {
       dataSource = (function () {
           var re = new RegExp('^((?:f|ht)tp(?:s)?\://[^/]+)', 'im');
           var match = dataSource.match(re);

           if (match == null)
             return dataSource;

           var origin = match[1].toString();
           var rest = dataSource.substr(origin.length, dataSource.length - origin.length);

           if (!rest || rest.length == 0 || rest === '/')
             return origin + '/';

           var lastIndexOf = rest.lastIndexOf('/');
           if (lastIndexOf == rest.length-1) {
             return origin + rest;
           }
           var restdir = rest.substr(0, lastIndexOf+1);
           // TODO: generalize, cutting of inapp instance will not work
           if (restdir.indexOf("inapp/", restdir.length - "inapp/".length) != -1) {
             restdir = rest + "/";
           }
           return origin + restdir;
       })();


       if (/^\/\//.test(dataSource)) {
         return window.location.protocol + dataSource;
       }

       return dataSource;
     };

      // Dispatches the message Events of the window to the
      // respective channels.
      var DispatchTable = function () {
        this.origin = URL.getOriginFromDataSource(browser.getURL());
      };

      _.extend(DispatchTable.prototype, {
        // a mapping from dataSource to channel
        channels: [],

        // register a channel
        register: function (channel) {
          this.channels.push(channel);
        },

        // dispatch a message event
        dispatch: function (e) {
          var that = this;
          _.forEach(this.channels, function (channel, id) {
              var dataSource = channel.get("dataSource"),
                  messageFrameStart = channel.getMessageFrameStart(dataSource),
                  loginWindow = loginHandler.getLoginWindow(channel),
                  isChannel, 
                  message;

            try {
              isChannel = channel.iframe.contentWindow === e.source
                          || ((loginWindow === e.source || (loginWindow && loginWindow.contentWindow === e.source && e.origin === channel.get("dataSource").substring(0, e.origin.length))) && loginWindow.getAttribute("data-channel") === channel.get("url"))
            } catch (ex) {
              // avoid permission denied errors
              isChannel = false;
            }

            if (isChannel) {
              message = e.data && e.data.replace && e.data.replace(messageFrameStart, "");
              try {
                message = JSON.parse(message);
              } catch (ex) {}

              channel.messageReceived(message);
            }
          });
        }
      });

      var dispatchTable = new DispatchTable();

  // Listen for message events and dispatch them
  if (browser.getWindow()) {
    $(browser.getWindow()).bind('message', function (e) {
      dispatchTable.dispatch(e.originalEvent);
    });
  }

  function MessageFrameCall(url, request, method, dataType, headers, formatOptions) {
    this.cid = _.uniqueId('c');
    this.url = url;
    this.request = request;
    this.method = method;
    this.dataType = dataType || "json";
    this.headers = headers;
    this.formatOptions = formatOptions;
  }
  _.extend(MessageFrameCall.prototype, Backbone.Events, {
    
    dispose: function() {
      
      this.trigger("dipose");
      
    },
    
    toMessage: function() {
      if (/^json$/i.test(this.dataType)) {
        return JSON.stringify(this.request);
      }
      return this.request;
    },
    
    done: function(data) {
      this.trigger("response", data, this.url);
    },

    failed: function (data) {
      this.trigger("error", data, this.url);
    }
    
  });  

  var MessageFrame = Backbone.Model.extend({

    defaults: {
      enabled: true
    },

    initialize: function (attributes, options) {
      options = options || {};
      this.options = options;
      var that = this;

      if (!idpRegistry.idpEnabled(idpRegistry.getIdp(that))) {
        this.set("enabled", false);
      }

      idpRegistry.on("idpenabledchanged", function () {
        that.set("enabled", idpRegistry.idpEnabled(idpRegistry.getIdp(that)));
      });

      var messageFramePath = options.messageFramePath;
      var target = options.target;
      this.set("dataSource", normalizeDataSource(this.get("url").replace(/api\/v2\/.*/i, "")));
      var messageFramePathFallback =  '../messageFrame.html?' + URL.getOriginFromDataSource(window.location.href);
      this.set("messageFramePath", messageFramePath || messageFramePathFallback);
      this.set("dataSourceOrigin", URL.getOriginFromDataSource(this.get("url")));
      this.set("target", target || 'body');
      this.calls = {};
      this.remoteWindow; /* ... */
      var that = this;
      window.setTimeout(function () {
          that.connect();
        }, 0);
    },

      // post a message to the messageFrame.
      // the message must be JSON-serializable
      perform: function (call, force) {
        if (!force && this.calls[call.cid] != null) {      
          return this.calls[call.cid];
        }

        this.calls[call.cid] = call;
        // this.call.listenTo("dispose", )
        this.verifyConnection();
        if (!this.iframe || !this.iframe.contentWindow) return;

        // Due to new CORS channel, export.js now uses POST method but messageframe supoprts download method only.
        if (
          call.method &&
          call.method.toLowerCase() === 'post' && 
          call.formatOptions &&
          call.formatOptions.responseType === 'blob'
        ) {
          call.method = "download";
        }

        try {
          var message = JSON.stringify({
              headers: call.headers,
              method: call.method,
              dataSource: call.url,
              dataType: call.dataType,
              urlPath: "",
              handleLogin: false,
              parameters: call.toMessage(),
              id: call.cid,
              formatOptions: call.formatOptions
            }
          );
          this.iframe.contentWindow.postMessage(
            message,
            this.get("dataSourceOrigin")
          );
        } catch (e) {
          this.reconnect();
          throw new Error("Lost connection");
        }
      },

      getMessageFrameStart: function (dataSource) {
        if (_.isFunction(this.options.getMessageFrameStart)) return this.options.getMessageFrameStart(dataSource);
        return new RegExp("^messageFrame:" + URL.getOriginFromDataSource(dataSource) + "[^:]*:"); // replace until after first : after origin,
      },

      restartActiveCalls: function () {
        var that = this;

        _.each(this.calls, function (call) {
            that.perform(call, true);
        });
      },

      messageReceived: function (message, e) {
        var that = this;

        if (message && message._tag === 'messageFrameInfo') {
          idpRegistry.register(message.idpURL, this);
          if (message.sendsReceivedOnPostMessage) {
            this.verifyConnectionTimeoutMs = VERIFY_CONNECTION_TIMEOUT_MS;
          } else {
            this.verifyConnectionTimeoutMs = null;
          }
        } else if (message === "loggedIn:" || message && message._tag === "loggedIn") {
          this.set("loggedIn", true);
          loginHandler.hideLogin(this);
          this.restartActiveCalls();
          var channels = idpRegistry.getChannelsForIdp(idpRegistry.getIdp(this));
          _.each(channels, function (channel) {
              if (channel.get("url") === that.get("url")) {
                channel.set("loggedIn", true);
              }
              if (!channel.get("loggedIn")) {
                loginHandler.loginInBackground(channel);
              }
          });
        }

        this.connected();
        this.clearMessageId(message._messageId);
        if (message && message._tag === 'received') {
          return;
        }

        var showLogin = false;
        if (/loginrequired/i.test(message._tag)) {
          showLogin = true;
        } else if (/messageFrameInfo/.test(message._tag)) {
          this.idpURL = message.idpURL === "null" ? null : message.idpURL;
          return;
        }

        if (message.status === 401 || /<meta http-equiv=\"refresh\"/.test(message.result)) {
          showLogin = true;
        }

        if (showLogin) {
          this.set("loggedIn", false);
          this.$focusAfterLogin = $(":focus");
          if (!this.options.loginAsError) {
            loginHandler.showLogin(this);
            return;
          }
          else {
            message._tag = "ajaxError";
            message.status = 401;
            message.error = "Synthesized error from login info.";
          }
        }

        var call = this.calls[message.id];
        if (call) {
          if (/ajaxError/.test(message._tag)) {
            call.failed({
                status: message.status,
                message: message.result,
                url: call.url,
                error: message.error
            });
          } else {
            call.done(message.result);
          }
          this.calls[message.id] = null;
          delete this.calls[message.id];
        }
      },

      clearMessageId: function (cid) {
        if (!cid) {
          return;
        }

        // TODO: property list vs. array?
        this.calls = _.select(this.calls, function (originalMessage) {
            return originalMessage.cid !== cid;
        });
      },

      verifyConnection: function () {
        var that = this;
        if (this.verifyConnectionTimeoutMs) {
          window.clearTimeout(this.verifyConnectionTimeout);
          this.verifyConnectionTimeout = window.setTimeout(function () {
              that.reconnect();
            }, this.verifyConnectionTimeoutMs);
        }
      },

      reconnect: function () {
        this.disconnect('lost connection');
        this.connect();
      },

      // open channel.
      // (add iframe)
      connect: function () {
        dispatchTable.register(this);
        this.appendIframe();
      },

      appendIframe: function () {
        this.iframe = document.createElement('iframe');
        this.iframe.style.display = 'none';
        this.iframe.src = normalizeDataSource(this.get("url")) + this.get("messageFramePath");
        this.iframe.title = "iframe for postmessage commmunication";
        this.iframe.onload = _.bind(this.connected, this);
        $(this.get("target")).append(this.iframe);
      },

      connected: function () {
        if (!this._connected) {
          this._connected = true;
          
          /*          this.postNotification({
              _tag: 'connected'
          });*/

          this.restartActiveCalls();
        }

        window.clearTimeout(this.verifyConnectionTimeout);
        delete this.verifyConnectionTimeout;

      },

      // close channel.
      // (remove iframe)
      disconnect: function (reason) {
        try {
          this.iframe.parentNode.removeChild(this.iframe);
        } catch (e) {
          /* ignore */
        }
        this._connected = false;
        /*        this.postNotification({
            _tag: 'disconnected',
            reason: reason
        });*/
      },

      _receiveMessage: function(event) {

        /*
        * dataSource":"https://at.folio.fabasoft.com/search/","id":"1_1369150911350","transportId":1,"_messageId":"6C620619E0F64C459AE0D215D2649B52"}"
        * 
        */

        var id = event.data.cid;
        var call = this.calls[id];
        if (!call) {

        }
        else {
          call.done(event.data);        
        }
      }  

  });

  function MessageFrames(options) {
    // this.window = window; 
    // this.el = el;
    this.options = options || {};
  }

  MessageFrames.Call = MessageFrameCall;
  MessageFrames.idpRegistry = idpRegistry;

  _.extend(MessageFrames.prototype, {

      _idFromUrl: function(url) {
        return url;      
      },

      forURL: function(url, options) {
        var id = this._idFromUrl(url);
        if (!frames[id]) {
          frames[id] = new MessageFrame({
              url: url
            },
            _.extend({}, this.options, options)
          ); 
        }
        return frames[id];
      },

      enableIdpOfChannel: function (channel) {
        idpRegistry.enableIdp(idpRegistry.getIdp(channel));
      }

  });


  return MessageFrames;

});



